import React, { useState } from 'react';
import ProposalCard from './proposalCard';
import ProposalCardLoader from './proposalCardLoader';
import { getDateString } from '../../../utils/dateTime';
import { useTranslation } from 'react-i18next';
import UtilityButton from '../../buttons/utilityButton';
import PlusIcon from '../../atoms/icons/plus';

const Proposals = ({
  data,
  charterTypeId,
  period,
  setPeriod,
  periods,
  sortOrder,
  offerCode,
  destination,
  destinations,
  loading,
  hotel,
  setModalProposal,
}) => {
  const { t } = useTranslation(['booking']);

  if (!loading && data?.periods) {
    const date = getDateString(period.out, period.home);
    const currentIndex = periods.findIndex(
      (dp) => dp.out === period.out && dp.home === period.home,
    );

    //const previousPeriod = currentIndex > 0 ? periods[currentIndex - 1] : null;
    const nextPeriod =
      currentIndex < periods.length - 1 ? periods[currentIndex + 1] : null;

    if (data?.periods?.length > 0) {
      let proposals = data.periods.reduce((acc, period) => {
        period.proposals.forEach((proposal) => {
          acc.push(proposal);
        });
        return acc;
      }, []);

      const rooms = data.searchInfo.rooms;

      if (sortOrder === 'recommended') {
        proposals = proposals.sort((a, b) => b.priority - a.priority);
      } else {
        proposals = proposals.sort((a, b) => a.price - b.price);
      }
      const childrenCount = rooms.reduce((count, room) => {
        return (
          count + room.travelers.filter((traveler) => traveler.age < 18).length
        );
      }, 0);

      const featuredProposals = hotel
        ? proposals.filter((p) => p.hotel.hotelId === hotel)
        : null;

      const filteredProposals = hotel
        ? proposals.filter((p) => p.hotel.hotelId !== hotel)
        : proposals;

      return (
        <div
          className={`sticky top-24 w-full h-auto grid gap-2 md:gap-4 grid-cols-12 max-w-screen-xl mx-auto`}
        >
          {featuredProposals?.length > 0 &&
            featuredProposals.map((p, i) => {
              if (p.hotel?.hotelId === 'BADR') return null;
              return (
                <ProposalCard
                  key={
                    p.flightCharter?.id +
                    p.hotel?.charterPeriodId +
                    p.package?.id +
                    i
                  }
                  proposal={p}
                  charterTypeId={charterTypeId}
                  rooms={rooms}
                  layout={'list'}
                  hasChildren={childrenCount > 0}
                  offerCode={offerCode}
                  setModalProposal={setModalProposal}
                />
              );
            })}
          {/*featuredProposals?.length > 0 && (
            <div className="col-span-12 px-4 py-4 bg-yellow-15 rounded">
              <h4 className="w-full flex items-center">Alternativa hotell</h4>
            </div>
          )*/}
          {filteredProposals.map((p, i) => {
            if (p.hotel?.hotelId === 'BADR') return null;
            return (
              <ProposalCard
                key={
                  p.flightCharter?.id +
                  p.hotel?.charterPeriodId +
                  p.package?.id +
                  i
                }
                proposal={p}
                charterTypeId={charterTypeId}
                rooms={rooms}
                layout={filteredProposals.length > 1 ? 'grid' : 'list'}
                hasChildren={childrenCount > 0}
                offerCode={offerCode}
                setModalProposal={setModalProposal}
              />
            );
          })}
          {nextPeriod && (
            <div className="col-span-12 px-4 pt-4 bg-yellow-15 rounded">
              <div className="-mx-1">
                <UtilityButton
                  onClick={() => setPeriod(nextPeriod)}
                  disabled={!nextPeriod}
                  label={t('Show period', {
                    date: getDateString(nextPeriod.out, nextPeriod.home),
                  })}
                ></UtilityButton>
              </div>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div
          className={`sticky top-0 w-full h-auto mt-4 grid gap-2 md:gap-4 grid-cols-12 max-w-screen-xl mx-auto rounded bg-yellow-15`}
        >
          <div className="col-span-12 px-4 pt-4 bg-yellow-15">
            <span className="info w-full flex items-center">
              <span className="pt-1 ">
                <h4>{t('Could not find any proposals', { date: date })}</h4>
                <p>{t('No proposals found')}</p>
              </span>
            </span>
          </div>
          {nextPeriod && (
            <div className="col-span-12 px-4 pb-0 bg-yellow-15">
              <UtilityButton
                onClick={() => setPeriod(nextPeriod)}
                disabled={!nextPeriod}
                label={t('Show period', {
                  date: getDateString(nextPeriod.out, nextPeriod.home),
                })}
              ></UtilityButton>
            </div>
          )}
        </div>
      );
    }
  } else {
    return (
      <div
        className={`relative w-full h-auto grid gap-2 md:gap-4 grid-cols-12 max-w-screen-xl mx-auto`}
      >
        <ProposalCardLoader />
        <ProposalCardLoader />
        <ProposalCardLoader />
      </div>
    );
  }
};

export default Proposals;
